import { Type, TSchema } from "@sinclair/typebox";
import SchemaValidator from "../schema-validator";

const recordingModeType = Type.Union([Type.Literal("off"), Type.Literal("normal"), Type.Literal("strict")]);

const proctoringOptionProfileType = Type.Union([
	Type.Literal("institute"),
	Type.Literal("course"),
	Type.Literal("user"),
	Type.Literal("assessment"),
]);

function OptionalOrNull<T extends TSchema>(type: T) {
	return Type.Optional(Type.Union([Type.Null(), type]));
}

export const proctoringOptionType = Type.Object({
	enforceLockdown: Type.Boolean(),
	enforceMobile: Type.Boolean(),
	isExtension: Type.Boolean(),
	isLockdown: Type.Boolean(),
	isMobile: Type.Boolean(),
	videoRecordingMode: recordingModeType,
	audioRecordingMode: recordingModeType,
	recordScreen: Type.Boolean(),
	recordWebTraffic: Type.Boolean(),
	excludedWebTrafficRecordingUrls: OptionalOrNull(Type.Array(Type.String())),
	recordClipboard: Type.Boolean(),
	recordInput: Type.Boolean(),
	oneScreenEnforcementMode: recordingModeType,
	disableNewTab: Type.Boolean(),
	closeOpenTabs: Type.Boolean(),
	tabWhiteList: OptionalOrNull(Type.Array(Type.String())),
	tabBlockList: OptionalOrNull(Type.Array(Type.String())),
	keyboardShortcutBlockList: OptionalOrNull(Type.Array(Type.String())),
	disableClipboardMode: Type.Union([Type.Literal("off"), Type.Literal("tab"), Type.Literal("system")]),
	disableSpellcheck: Type.Boolean(),
	disablePrinting: Type.Boolean(),
	disableRightClick: Type.Boolean(),
	disableDownloadFiles: Type.Boolean(),
	hideOtherWindows: Type.Boolean(),
	showRecordingPanel: Type.Boolean(),
	idVerification: Type.Boolean(),
	idVerificationEnableAi: Type.Boolean(),
	faceTrackingMode: recordingModeType,
	objectDetectionMode: recordingModeType,
	applicationBlockMode: recordingModeType,
	blockWindowedApplications: Type.Boolean(),
	applicationBlockList: OptionalOrNull(Type.Array(Type.String())),
	allowedApplicationsList: OptionalOrNull(Type.Array(Type.String())),
	blockVirtualMachines: Type.Boolean(),
	scanRoom: Type.Boolean(),
	quietEnvironment: Type.Boolean(),
	enableCalculator: Type.Union([Type.Literal("off"), Type.Literal("scientific"), Type.Literal("standard")]),
	enableWhiteboard: Type.Boolean(),
	uploadScratchNotes: Type.Boolean(),
	idVerificationMode: recordingModeType,
});

export const proctoringOptionProfile = Type.Object({
	id: Type.Number(),
	name: Type.Union([Type.Null(), Type.String()]),
	type: proctoringOptionProfileType,
	proctoringOption: Type.Object({
		...proctoringOptionType.properties,
	}),
	instituteProfile: OptionalOrNull(
		Type.Object({
			id: Type.Number(),
			enforced: Type.Boolean(),
			instituteId: Type.Number(),
			proctoringOptionProfileId: Type.Number(),
		}),
	),
	courseProfile: OptionalOrNull(
		Type.Object({
			id: Type.Number(),
			courseId: Type.Number(),
			proctoringOptionProfileId: Type.Number(),
		}),
	),
	userProfile: OptionalOrNull(
		Type.Object({
			id: Type.Number(),
			userId: Type.Number(),
			proctoringOptionProfileId: Type.Number(),
		}),
	),
});

const profiles = new SchemaValidator(Type.Array(proctoringOptionProfile));

const enforced = new SchemaValidator(Type.Object({ enforced: Type.Boolean() }));

export default {
	profile: new SchemaValidator(proctoringOptionProfile),
	profileOrNull: new SchemaValidator(Type.Union([Type.Null(), proctoringOptionProfile])),
	profiles,
	enforced,
	proctoringOption: new SchemaValidator(proctoringOptionType),
};
